import React, { useContext } from 'react';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext.js';
import { Button } from '../../button/index.js';
import { ProgressionBar } from '../../progression-bar/index.js';
import { getScoreAsPercentage, getMessageForPercentage } from '../util/score-utils.js';
import { ExerciseManagerContext } from '../contexts/ExerciseManagerContext.js';
import styles from './exercise-states.module.css.js';

const Container = ({ children }) => (React.createElement("div", { className: styles.overlay },
    React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.icon },
            React.createElement("i", { className: 'bc-icon bc-icon-exercise-fill', role: 'img' })),
        children)));
const ExercisePaused = ({ result, onClose }) => {
    const translations = useContext(ExerciseTranslationsContext);
    const incompleteSession = result.score.achievable !== result.score.maximum;
    const percentage = getScoreAsPercentage(result.score.achieved, result.score.achievable);
    const scoreFeedbackMessage = getMessageForPercentage(percentage, translations.exercisePausedState.messages.veryGood, translations.exercisePausedState.messages.wellDone, translations.exercisePausedState.messages.bad);
    const { showScore } = useContext(ExerciseManagerContext);
    if (showScore)
        return (React.createElement(Container, null,
            React.createElement("div", { className: styles.message },
                React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar }),
                React.createElement("p", null, translations.exercisePausedState.showScore.title),
                React.createElement("div", { className: styles.buttons },
                    React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exercisePausedState.buttons.close)))));
    return (React.createElement(Container, null,
        React.createElement("div", { className: styles.message },
            React.createElement("h2", { className: 'heading' }, translations.exercisePausedState.title),
            React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar }),
            incompleteSession && React.createElement("p", null, translations.exercisePausedState.messages.incomplete),
            React.createElement("p", null, scoreFeedbackMessage),
            React.createElement("div", { className: styles.buttons },
                React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exercisePausedState.buttons.close)))));
};

export { ExercisePaused };
